export enum CompanyThemeEnum {
  InmobiliariaPlatino = "theme-inmobiliaria-platino",
  ResidencialMaya = "theme-residencial-maya",
  Invalle = "theme-invalle",
}
